import {Logic} from './Type'
import * as moment from 'moment'

export type Menu = {
    title: string
}

export type Player = {
    id: string
    name: string
    username: string
    password: string
    email: string
    site: string
    credits?: string
}

export type LevelInfo = {
    LevelNames: string[]
    SublevelNames: string[]
}

export type ShopItem = {
    fromtime: string
    totime: string
    players: number[]
    banner: number
    title: string[]
    image: string
    price: number
    discount: number
    index: number
    idx: number
    discountedPrice: number
    active: boolean
    free_round: boolean
    info: string[]
    t_c: string[]
    category: number
    newly: boolean
    multi: boolean
    id: number
}

export type RewardShopItemCheckout = {
    name:string
    price:string
    quantity:string
    value:string
    id:string
    category: string
}

export class IndexState extends Logic.Type {
    JWT: string
    ALLOW_TRANSACTIONS: boolean = true
    countTotal: number = -1
    page: number = -1
    pages: number = -1
    ACT_AS_CUSTOMER: boolean = false
    PLAYERID: number
    custom: {
        Slots: number,
        slots: number,
        christmas: string,
        comingsoon: number,
        blackFriday: string,
        activeBlackFriday: boolean,
        activeChristmas: boolean,
        categoriesPositioning: {top: number, left: number, width: number, circle: boolean, height: number}[]
        // imagesDescriptions: string[],
        // coinsGivenOnRegistration: number
    }
    from_date:moment.Moment|null = null
    to_date:moment.Moment|null = null
    focusedInput: any
    focusedInput2: any
    focusedInput3: any
    userCategory: Object[]
    userItem: Object[]
    userCategoryValue: string = '0'
    userItemValue: string = '0'
    notify: number[]
    allPlayerRst: any[]
    // : any[]
    PlayerLevel: number
    PlayerSubLevel: number
    minlevel: number[]
    languages: any[]
    translation: string[]
    images: string[]
    transactions: boolean
    InfoConfirm: boolean = false
    InfoConfirm2: boolean = false
    startAnimationBalance: boolean = false
    startAnimation: boolean = false
    w: number = 2000
    h: number = 1300
    W: number = 800
    H: number = 1000
    Info: boolean[] = [false, false, false, false, false, false, false, false, false, false, false, false] // items on one page
    center: number = 323
    centerTop: number = 40
    centerBottom: number = 830
    left: number = 188
    right: number = 610
    top: number = 165
    bottom: number = 720
    box: number = 150
    Category: number = 0
    menuItems: Menu[]
    bigMenuItems: Menu[]
    bigMenuV : JSX.Element[]
    bigMenuN : JSX.Element[]
    // copyrightAfter: string
    runOnce:boolean = true
    Site:string
    Logo:string
    Logo2:string
    games_folder: string
    mail: string[]
    category: string[]
    subdomain:string
    Username:string = ''
    Password:string = ''

    Email:string = ''
    Name:string = ''
    Id:string = ''

    UsernameNew:string = ''
    PasswordNew:string = ''

    EmailNew:string = ''
    NameNew:string = ''
    
    name: string
    show_game_info:boolean
    show_version_info:boolean
    show_debug_info:boolean
    displayName: boolean
    borders:boolean
    // menus:string[]
    // menus_type:string[]
    // groups:string[]
    shopItemDefaultFilename:string
    shopItems: ShopItem[] = []
    PointsXP: number = 0
    PointsXPL: number = 0
    PointsXPLR: number
    PointsXPLRP: number
    PointsXPCheckout: number = 0
    ItemsCheckout: number
    sortActive:number = -1
    sortActiveT:number = -1
    sortPrice: boolean = false
    sortName: boolean = false
    sortDiscount: boolean = false
    sortBuyin: boolean = false
    sortTitle: boolean = false
    sortDate: boolean = false
    // optin: boolean[]
    // show_leaderboard: boolean = false
    // show_info: boolean = false
/*
    myPosition: number = 0
    myPositionBetter: boolean = false
    myPositionWorse: boolean = false
    myPoints: number = 0
    myPointsChanged: boolean = false
*/
/*
    TitleCreateAccount :string
    TitleEditAccount :string
    MessageAccountCreated:string
    MessageAccountEdited:string
*/
    RewardShopCheckout:JSX.Element
    RewardShopCheckoutItems: RewardShopItemCheckout[]
    RewardShopChange: boolean = false
    RewardShopCheckoutSum: number
    RewardShopMode: boolean = false
    countTournamentCalled: boolean = false
    // expand: boolean = false
    tournamentStream: Object[] // transactions    
    rstStream:Object[] // transactions
    // RstStream:Object[] // bundled transactions
    RSTStream:Object[] // all transactions in bundled transactions
    countRstCalled:boolean = false
    // Expand:number[]
    pNum :number = 0
    pSize :number = 20
    offset: string = '0'
    count :number = 0
    // Count :number = 0
    countT :number = 0
    pNumT :number = 0
    pSizeT :number = 20
    offsetT: string = '0'
    data: any
    title_size: string = '30px'
    title_color: string = '#005487'
    cover_whole:boolean = false
    border_radius: number = 0
    height_below:string = '43px'
    b:number = 2
    border:string = '2px solid #6698b7'
    progress:number = 0
    levels_altogether:number = 0
    finalLevelName:string
    currentLevel:number = -1
    currentSubLevel:number = -1
    currentLevelName:string = ''
    levels:string[]
    sublevels:number[]
    subLevels:number
    Levels: Object[]
    LevelsCountCalled: boolean = false
    Points: Object[]
    PointsCountCalled: boolean = false
    terms: boolean = false
    default_language: number
    shop_main_left_height: number = 0
}


// WEBPACK FOOTER //
// ./src/Logic/Index.ts